import { render, staticRenderFns } from "./Fleet.vue?vue&type=template&id=204153d9&scoped=true&"
import script from "./Fleet.vue?vue&type=script&lang=js&"
export * from "./Fleet.vue?vue&type=script&lang=js&"
import style0 from "./Fleet.vue?vue&type=style&index=0&id=204153d9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204153d9",
  null
  
)

export default component.exports